﻿/* Resources URLs */
export const MAP_RESOURCES_URL = 'map/resources?type=map';
export const MAP_UI_RESOURCES_URL = 'map/resources?type=mapUI';

/* Settings URLs */
export const HIDE_EXTERNAL_LAYER = 'map/hideexternalmaplayer?IdExtMapLayer=';
export const SHOW_EXTERNAL_LAYER = 'map/unhideexternalmaplayer?IdExtMapLayer=';
export const MAP_GENERAL_SETTINGS_URL = 'map/maprungeneralsettings?id=';
export const MAP_GIS_SETTINGS_URL = 'map/getgissettings';
export const MAP_GET_FEATURE_URL = 'map/getfeature';
export const MAP_LAYERS_SETTINGS_URL = 'map/maprunlayerssettings?id=';
export const MAP_LAYER_BBOX_URL = 'map/GetBBox?idMap={0}&layer={1}&srs={2}&filter={3}';
export const MAP_EXTERNAL_LAYERS_SETTINGS_URL = 'map/getuserexternalmaplayer?idExtEntity={0}&idMap={1}';
export const CLASSIC_STYLE_SETTINGS_URL = 'style/classicstylerulesform?id=';
export const MAP_GENERAL_ACTIONS_SETTINGS_URL = 'map/getmapgeneralactions?idMap=';
export const SYST_COORD_URL = 'systcoord/systcoord?id=';
export const GEOSERVICE_SETTINGS_URL = 'geoservice/getbyid?id=';
export const PROXY_URL = "xpproxy/";
export const GSPROXY_URL = "gsproxy/";
export const LAYER_PREVIEW_URL = 'img/style/{id}_{rule}.png';
export const STYLE_URL = 'style/getstyle?id=';
export const SYSTEM_STYLE_URL = 'style/GetSystemStyle?systemType=';
export const STYLE_PREVIEW_URL = 'img/style/';
export const MAP_GEOSERVICE_LAYERS = 'geoservice/getconfiggeoservices';
export const MAP_GEOSERVICE_FIELDS = 'geoservice/getgeoservicefields?id=';
export const MAP_GEOSERVICE_FIELDS_DESCRIPTOR = 'geoservice/GetGeoserviceFieldsDescriptor?id=';
export const GET_FIELD_RANGE = 'entity/getentityfieldrangebyname?idEntity={0}&fieldName={1}';
export const GET_FIELD_CLASSIFICATION = 'entity/getentityfieldclassification?idEntity={0}&fieldName={1}&method={2}&classCount={3}';
export const ANALYSIS_URL = 'map/getanalysefeature';
export const MAP_ENTITY_GET_FIELDS = 'entity/getfieldsbyentityid?idEntity=';
export const MAP_LAYER_FILTER = 'UILayout/GetUILayoutRuntime?id=';
export const MAP_EXTERNAL_LAYER_FILTER = 'extconn/getmaplayerfilter?idGeoField={0}&idMap={1}';